import itemId from 'owa-service/lib/factory/itemId';
import recurringMasterItemId from 'owa-service/lib/factory/recurringMasterItemId';
import type { ClientItemId } from 'owa-client-ids';
import { getCalendarEventService } from './getCalendarEventService';
import { getBirthdayEventService } from './getBirthdayEventService';
import type { CalendarEntry } from 'owa-graph-schema';
import { getCalendarEntryByFolderId, isTeamsCalendarEntry } from 'owa-calendar-cache';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import type { GetCalendarEventResponse } from '../types/GetCalendarEventResponse';
import type ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';

/**
 * Loads the calendar event from the server based on item id
 * @param id id of the event that we want to load
 * @param getSeriesMaster flag which says whether we want series master or series instance
 */
export function loadCalendarEvent(
    id: ClientItemId,
    parentFolderId: string,
    shape: ItemResponseShape,
    fetchMasterItemFromOccurence: boolean = false
): Promise<GetCalendarEventResponse> {
    const calendarEntry: CalendarEntry = getCalendarEntryByFolderId(parentFolderId);
    if (
        calendarEntry &&
        calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.BirthdayCalendar
    ) {
        // invoke the getirthdayEvent operation to get calendar event for birthday
        return getBirthdayEventService(id, parentFolderId);
    }
    const eventIds = [
        fetchMasterItemFromOccurence
            ? recurringMasterItemId({ OccurrenceId: id.Id })
            : itemId({ Id: id.Id }), // special case fetching the series master with the occurence id This will break (how it is currently ) for declined events
    ];
    // Invoke the service to get the data
    return getCalendarEventService(
        id,
        shape,
        fetchMasterItemFromOccurence,
        eventIds,
        isTeamsCalendarEntry(calendarEntry) ? parentFolderId : undefined
    );
}
